import {Controller} from "@hotwired/stimulus";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'reject-case-modal',
    ];

    static values = {
        chatId: Number,
        // DDT-3916: the post-reply decline link reports a different event than the header button.
        gaCategory: {type: String, default: 'messages'},
        gaAction: {type: String, default: 'messages_chat_reject_case_cta_clicked'},
    };

    openModal(event) {
        if (event) {
            event.preventDefault();
        }

        this.rejectCaseModalOutlet.chatIdValue = this.chatIdValue;
        this.rejectCaseModalOutlet.showContent(event)

        dataLayer.push({
            "event": "dataLayer.gaEvent",
            "gaEvent": {
                "category": this.gaCategoryValue,
                "action": this.gaActionValue,
            },
        });
    }
}
